<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="评价月" prop="monthList">
                    <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="facilityName">
                    <el-input v-model="queryCondition.facilityName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodeList">
                    <el-select v-model="queryCondition.category2CodeList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodeList">
                    <el-select v-model="queryCondition.category3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="指标类型" prop="factorType">
                      <el-select v-model="queryCondition.factorType" disabled style="width:100%">
                        <el-option :key="index" v-for="(item,index) in factorTypeOptions" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="供应商集团名称" prop="groupName">
                      <el-input v-model="queryCondition.groupName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="等级" prop="grade">
                      <el-select v-model="queryCondition.grade" style="width:100%" v-if="queryCondition.factorType==='SQMS'">
                        <el-option :key="index" v-for="(item,index) in gradeOptions" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                      <ic-select v-else clearable table="TT_QSPI_FACILITY_FACTOR_SCORE" field="GRADE" v-model="queryCondition.grade" placeholder="请选择" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select clearable table="TT_QSPI_FACILITY_FACTOR_SCORE" field="STATUS" v-model="queryCondition.status" placeholder="请选择" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="factorType==='SQMS'">
                  <el-col :span="6">
                    <el-form-item label="只显示有附件" prop="isExistDocument">
                      <el-checkbox v-model="queryCondition.isExistDocument"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="QSPI_MSV_SUBMIT,QSPI_SWA_SUBMIT,QSPI_SQMS_SUBMIT,QSPI_GOVTCERT_SUBMIT,QSPI_SPECCOMP_SUBMIT,QSPI_COA_SUBMIT,QSPI_REGCOMP_SUBMIT,QSPI_GOVTPLANT_SUBMIT,QSPI_OTHSTOCKRECOVER_SUBMIT,QSPI_PRDFEEDBACK_SUBMIT,QSPI_SENSORY_SUBMIT,QSPI_OTHQIP_SUBMIT,QSPI_ANTICHICK_SUBMIT,QSPI_OTHQBR_SUBMIT">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onBatchModify" v-acl="QSPI_SENSORY_BATCH_SAVE,QSPI_PRDFEEDBACK_BATCH_SAVE,QSPI_OTHSTOCKRECOVER_BATCH_SAVE,QSPI_GOVTPLANT_BATCH_SAVE,QSPI_REGCOMP_BATCH_SAVE,QSPI_COA_BATCH_SAVE,QSPI_SPECCOMP_BATCH_SAVE,QSPI_GOVTCERT_BATCH_SAVE,QSPI_SQMS_BATCH_SAVE,QSPI_SWA_BATCH_SAVE,QSPI_MSV_BATCH_SAVE,QSPI_OTHQIP_BATCH_SAVE,QSPI_ANTICHICK_BATCH_SAVE,QSPI_OTHQBR_BATCH_SAVE">批量修改</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_MSV_EXPORT,QSPI_SWA_EXPORT,QSPI_SQMS_EXPORT,QSPI_GOVTCERT_EXPORT,QSPI_SPECCOMP_EXPORT,QSPI_COA_EXPORT,QSPI_REGCOMP_EXPORT,QSPI_GOVTPLANT_EXPORT,QSPI_OTHSTOCKRECOVER_EXPORT,QSPI_PRDFEEDBACK_EXPORT,QSPI_SENSORY_EXPORT,QSPI_OTHQIP_EXPORT,QSPI_ANTICHICK_EXPORT,QSPI_OTHQBR_EXPORT">导出</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onUpdate" v-if="queryCondition.factorType==='PRODUCT_FEEDBACK'" v-acl="QSPI_PRDFEEDBACK_EXPORT">更新问题等级</el-button>
      </el-row>
      <el-table ref="plxTable" :data="tableData" @selection-change="selectionChange" :cell-class-name="tableCellClassName" max-height="650" border highlight-current-row>
        <!-- <el-table-column align="center" type="checkbox" width="80" /> -->
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="评价月" show-overflow-tooltip prop="month" min-width="80"></el-table-column>
        <el-table-column align="center" label="Category2" show-overflow-tooltip prop="category2Name" min-width="90"></el-table-column>
        <el-table-column align="center" label="供应商集团名称" show-overflow-tooltip prop="groupName" min-width="140"></el-table-column>
        <el-table-column align="center" label="Facility名称" show-overflow-tooltip prop="facilityName" min-width="180">
          <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row,scope.$index)" v-if="scope.row.isCanAudit">{{scope.row.facilityName}}</el-button>
            <p v-else @click="onDetail(scope.row,scope.$index)">{{scope.row.facilityName}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="等级" prop="grade" min-width="70">
          <template v-slot="scope">
            <el-button type="text" @click="onGoTo(scope.row,scope.$index)" v-if="(factorType==='QBR'&&ms_Permission.indexOf('QSPI_QBR_QUERY')!==-1)||(factorType==='MSV'&&ms_Permission.indexOf('Msv-reportQueryData')!==-1)||(factorType==='SENSORY'&&ms_Permission.indexOf('Sensory-reportQuery')!==-1)||(factorType==='PRODUCT_FEEDBACK'&&ms_Permission.indexOf('Feedback-reportsList')!==-1)">{{scope.row.grade}}</el-button>
            <p v-else>{{scope.row.grade}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="调查报告是否延期" show-overflow-tooltip prop="feedbackDelayed" min-width="140" v-if="queryCondition.factorType==='PRODUCT_FEEDBACK'">
          <template v-slot="scope">
            <span v-if="!scope.row.feedbackDelayed"></span>
            <span v-else>延期</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="问题报告最高等级" show-overflow-tooltip prop="highestProblemLevel" min-width="140" v-if="queryCondition.factorType==='PRODUCT_FEEDBACK'"></el-table-column>
        <el-table-column align="center" label="分数" show-overflow-tooltip prop="score" min-width="70" v-if="queryCondition.factorType!=='SWA'&&queryCondition.factorType!=='PRODUCT_FEEDBACK'"></el-table-column>
        <el-table-column align="center" label="审核评级" show-overflow-tooltip prop="auditGrade" min-width="80" v-if="queryCondition.factorType==='SWA'"></el-table-column>
        <el-table-column align="center" label="Comment" show-overflow-tooltip prop="remark" min-width="200"></el-table-column>
        <el-table-column align="center" label="状态" show-overflow-tooltip prop="statusI18n" min-width="90"></el-table-column>
        <el-table-column align="center" label="截止日期" show-overflow-tooltip prop="deadline" min-width="120"></el-table-column>
        <el-table-column align="center" label="更新人" show-overflow-tooltip prop="updateName" min-width="100"></el-table-column>
        <el-table-column align="center" label="更新日期" show-overflow-tooltip prop="updateDate" min-width="120"></el-table-column>
        <el-table-column align="center" label="历史版本" min-width="100">
          <template v-slot="scope">
            <el-button type="text" @click="onView(scope.row,scope.$index)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="指标类型" show-overflow-tooltip :prop="factorType=='SWA'?'factorTypeI18n':'factorType'" min-width="120"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showBatchEditDialog" title="批量修改" append-to-body width="30%" :close-on-click-modal="false" @close="closeDialog">
      <el-form :model="detailForm" ref="detailForm" label-position="right" label-width="120px" :rules="rules">
        <el-row :gutter="20">
          <el-form-item label="分数" prop="score" v-if="factorType=='SQMS'">
            <el-input v-model="detailForm.score" @change="scoreChange" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="等级" prop="grade">
            <el-select v-model="detailForm.grade" style="width:100%" v-if="factorType==='SQMS'" disabled>
              <el-option :key="index" v-for="(item,index) in gradeOptions" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <ic-select v-else clearable table="TT_QSPI_FACILITY_FACTOR_SCORE" field="GRADE" @change="gradeChange" v-model="detailForm.grade" placeholder="请选择" style="width:100%"></ic-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="Comment" prop="remark">
            <el-input type="textarea" v-model="detailForm.remark" style="width:100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="onSave" type="primary">保存</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showHistoryDialog" title="评分历史版本" append-to-body width="80%" :close-on-click-modal="false" @close="closeHistoryDialog">
      <history-Dialog :arr="arr"></history-Dialog>
    </el-dialog>
    <el-dialog :visible.sync="showDetailDialog" title="评分" append-to-body width="30%" :close-on-click-modal="false" @close="closeDetailDialog">
      <detail-Dialog ref="aaaa" :editForm="editForm" :factorType="factorType" :ttQspiFacilityFactorScoreId="ttQspiFacilityFactorScoreId" :isCanAudit="isCanAudit" @closeDetailDialog="closeDetailDialog"></detail-Dialog>
    </el-dialog>
    <el-dialog :visible.sync="showDateDialog" title="请选择日期范围" append-to-body width="40%" :close-on-click-modal="false" @close="closeDateDialog">
      <el-form :model="dateForm" ref="dateForm" label-position="right" label-width="0px" :rules="dateFormRules">
        <el-row type="flex" align="middle" justify="space-between">
          <el-col :span="11">
            <el-form-item prop="dateFrom">
              <el-date-picker v-model="dateForm.dateFrom" type="month" value-format="yyyy-MM" placeholder="选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-form-item>
              <p style="width:100%;height:1px;background:#000;text-align:center"></p>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="dateTo">
              <el-date-picker v-model="dateForm.dateTo" type="month" value-format="yyyy-MM" placeholder="选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="onConfirm" type="primary">确认</el-button>
          <el-button size="mini" @click="onCancel" type="primary">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import otherApi from "@/api/other/index";
import QBRApi from "@/api/QBR/index";
import DQMPApi from "@/api/DQMP/index";
import historyDialog from './commonHistory.vue'
import detailDialog from './MaintainScoreTask.vue'
import maintainDialog from './MaintainScoreTask.vue'
import commonFunction from "@/utils/dataTableUtils";
import paginationMixin from '@/mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils";
import { materialService } from "@/api/base-data/material";

export default {
  name: '',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    historyDialog,
    maintainDialog,
    detailDialog
  },
  props: ['factorType', 'month', 'category2'],
  data() {
    var validateScore = (rule, value, callback) => {
      var reg = /^(0|\+?[1-9][0-9]*)$/
      if (value && !reg.test(value)) {
        callback(new Error('分数只能输入大于等于0的整数'));
      } else {
        callback();
      }
    };
    var validateGrade = (rule, value, callback) => {
      console.log('value', value);
      if (
        this.factorType !== "AAA" &&
        this.factorType !== "QBR" &&
        this.factorType !== "MSV" &&
        this.factorType !== "SWA" &&
        this.factorType !== "SQMS" &&
        this.factorType !== "SENSORY" &&
        !value
      ) {
        callback(new Error('请选择等级'));
      } else {
        callback();
      }
    };
    return {
      showHistoryDialog: false,
      showBatchEditDialog: false,
      showDetailDialog: false,
      showDateDialog: false,
      isShow: false,
      // isDisplay: true,
      ttQspiFacilityFactorScoreId: '',
      isCanAudit: null,
      ms_Permission: null,
      totalCount: 0,
      pages: 1,
      queryCondition: {
        monthList: [],  //评价月
        category2CodeList: [], //category2Code集合
        category3CodeList: [], //category3Code集合
        groupName: "", //供应商集团名称
        facilityName: "", //facility名称
        factorType: "", //指标类型
        status: "", //状态
        grade: "", //等级
        isExistDocument: "",//是否显示有附件的数据
        pageNum: 1,
        pageSize: 15,
      },
      detailForm: {
        grade: "",
        score: "",
        remark: "",
      },
      dateForm: {
        dateFrom: "",
        dateTo: "",
      },
      editForm: {},
      rules: {
        score: [
          { validator: validateScore, trigger: 'blur' }
        ],
        grade: [
          { validator: validateGrade, trigger: 'change' }
        ],
      },
      dateFormRules: {
        dateFrom: [
          { required: true, message: "请选择日期", trigger: 'blur' }
        ],
        dateTo: [
          { required: true, message: "请选择日期", trigger: 'change' }
        ],
      },
      ms_roles: [],
      category2List: [],
      category3List: [],
      monthOptions: [],
      tableData: [],
      multipleSelection: [],
      factorScoreIds: [],
      arr: [],
      factorTypeOptions: [],
      gradeOptions: [
        {
          label: "A",
          value: "A"
        },
        {
          label: "B",
          value: "B"
        },
        {
          label: "C",
          value: "C"
        },
        {
          label: "F",
          value: "D"
        },
      ]
    }
  },
  watch: {
    factorType: {
      handler(newV, oldV) {
        console.log('指标类型', newV);
        if (newV) {
          this.queryCondition.factorType = newV
        }
      },
      immediate: true
    },
    month: {
      handler(newV, oldV) {
        console.log('month', newV);
        if (newV) {
          this.queryCondition.monthList = newV
        }
      },
      immediate: true
    },
    category2: {
      handler(newV, oldV) {
        console.log('category2', newV);
        if (newV) {
          this.queryCondition.category2CodeList = newV
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.getCategory2Lists()
    this.getCategory3Lists()
    this.getMonth()
    this.getFacotrList()
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    setTimeout(() => {
      this.queryData()
    }, 1000);
  },
  methods: {
    queryData() {
      console.log('this.queryCondition', this.queryCondition);
      otherApi.getQspiQueryPage(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        // this.$refs.plxTable.reloadData(res.resultData)
      });
    },
    onUpdate() {
      this.showDateDialog = true
    },
    onConfirm() {
      this.$refs['dateForm'].validate((valid) => {
        if (valid) {
          otherApi.problemLevelRefresh(this.dateForm).then(res => {
            console.log('res', res);
            this.showDateDialog = false
            this.queryData()
          });
        }
      })
    },
    onCancel() {
      this.showDateDialog = false
      this.dateForm = {
        dateFrom: "",
        dateTo: "",
      }
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    getFacotrList() {
      otherApi.getFacotrList().then(res => {
        this.factorTypeOptions = res.data
      })
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2CodeList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        monthList: [],
        category2CodeList: [],
        category3CodeList: [],
        groupName: "",
        facilityName: "",
        factorType: this.factorType,
        status: "",
        grade: "",
        isExistDocument: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    onDetail(row, index) {
      console.log('this.queryCondition.factorType', this.queryCondition.factorType)
      sessionStorage.setItem('obj', JSON.stringify(this.queryCondition))
      this.factorType = row.factorType
      otherApi.findQspiDetail({
        ttQspiFacilityFactorScoreId: row.ttQspiFacilityFactorScoreId
      }).then(res => {
        if (res.code === '200') {
          this.editForm = res.data
          if (this.queryCondition.factorType == 'SWA') {
            this.editForm.factorType = res.data.factorTypeI18n
          } else {
            this.editForm.factorType = res.data.factorType
          }
          this.ttQspiFacilityFactorScoreId = row.ttQspiFacilityFactorScoreId
          this.isCanAudit = row.isCanAudit
          this.showDetailDialog = true
        }
      });
    },
    onGoTo(row, index) {
      if (this.factorType == 'QBR') {
        this.$router.push({
          path: "/qspiQBR",
          query: {
            // facilityCode: row.facilityCode
            ttQspiFacilityFactorScoreId: row.ttQspiFacilityFactorScoreId
          }
        })
      }
      if (this.factorType == 'MSV') {
        this.$router.push({
          path: "/visitReport",
          query: {
            // facilityCode: row.facilityCode
            ttQspiFacilityFactorScoreId: row.ttQspiFacilityFactorScoreId
          }
        })
      }
      if (this.factorType == 'SENSORY') {
        materialService.materialList({
          plantNo: row.facilityCode
        }).then((res) => {
          console.log('res', res);
          this.$router.push({
            path: "/sensoryReport",
            query: {
              // facilityCode: res.data.records[0].supplierName,
              ttQspiFacilityFactorScoreId: row.ttQspiFacilityFactorScoreId
            }
          })
        });
      }
      if (this.factorType == 'PRODUCT_FEEDBACK') {
        otherApi.getSupplierId({
          pageNum: 1,
          pageSize: 15,
          status: "1",
          supplierCode: row.facilityCode,
          supplierName: row.facilityName,
          type: "PLANT",
        }).then(res => {
          console.log('res', res);
          if (res) {
            this.$router.push({
              path: "/feedbackReport",
              query: {
                tmSupplierId: res.resultData[0].tmSupplierId,
                month: row.month
              }
            })
          }
        });
      }
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (this.factorType == 'MSV' || this.factorType == 'SENSORY' || this.factorType == 'PRODUCT_FEEDBACK' || this.factorType == 'SQMS' || this.factorType == 'QBR') {
        if (row.rank && column.property === 'grade') {
          return 'warn_row'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    onExport() {
      this.$set(this.queryCondition, 'factorScoreIds', this.factorScoreIds)
      otherApi.exportQspiFacilityFactorScore(this.queryCondition).then(res => {
        fileService.respToFile(res, this.factorType + '_Report.xlsx');
      });
    },
    onView(row, index) {
      otherApi.getQspiHistoryList({
        ttQspiFacilityFactorScoreId: row.ttQspiFacilityFactorScoreId
      }).then(res => {
        this.arr = JSON.stringify(res.data)
        this.showHistoryDialog = true
      });
    },

    // 选中的行
    selectionChange(row) {
      this.factorScoreIds = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.factorScoreIds.push(ele.ttQspiFacilityFactorScoreId)
      });
    },
    onSubmit() {
      if (this.factorScoreIds.length === 0) {
        this.$message.warning("请勾选数据")
        return false
      }
      // 不能进行提交的数据
      var arr1 = []
      const h = this.$createElement
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const ele = this.multipleSelection[i];
        if (!ele.isCanAudit) {
          arr1.push('您没有权限操作 ' + ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 的数据')
        }
        //  所有指标,已提交状态时,CQS都不可以批量修改;但是owner 已提交状态都可以批量修改+批量提交
        if (
          (this.factorType === 'MSV' && this.ms_Permission.indexOf('QSPI_MSV_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_MSV_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SWA' && this.ms_Permission.indexOf('QSPI_SWA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SWA_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'GOVT_CERT' && this.ms_Permission.indexOf('QSPI_GOVTCERT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTCERT_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'COA' && this.ms_Permission.indexOf('QSPI_COA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_COA_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SQMS' && this.ms_Permission.indexOf('QSPI_SQMS_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SQMS_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SPEC_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_SPECCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SPECCOMP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'REG_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_REGCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_REGCOMP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'GOVT_PLANT_AUDIT' && this.ms_Permission.indexOf('QSPI_GOVTPLANT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTPLANT_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'STOCK_RECOVERY' && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'PRODUCT_FEEDBACK' && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SENSORY' && this.ms_Permission.indexOf('QSPI_SENSORY_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SENSORY_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'QIP' && this.ms_Permission.indexOf('QSPI_OTHQIP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQIP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'ANTIBIOTIC_CHICKEN' && this.ms_Permission.indexOf('QSPI_ANTICHICK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_ANTICHICK_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'QBR' && this.ms_Permission.indexOf('QSPI_OTHQBR_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQBR_SAVE') !== -1 && ele.status === 'SCORED')
        ) {
          arr1.push(ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 评分已提交不能提交')
        }
        // 所有指标,超出截止日期时,CQS都不可以批量修改;但是owner超出截止日期都可以批量修改+批量提交
        if (
          (this.factorType === 'MSV' && this.ms_Permission.indexOf('QSPI_MSV_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_MSV_SAVE') !== -1) ||
          (this.factorType === 'SWA' && this.ms_Permission.indexOf('QSPI_SWA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SWA_SAVE') !== -1) ||
          (this.factorType === 'GOVT_CERT' && this.ms_Permission.indexOf('QSPI_GOVTCERT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTCERT_SAVE') !== -1) ||
          (this.factorType === 'COA' && this.ms_Permission.indexOf('QSPI_COA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_COA_SAVE') !== -1) ||
          (this.factorType === 'SQMS' && this.ms_Permission.indexOf('QSPI_SQMS_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SQMS_SAVE') !== -1) ||
          (this.factorType === 'SPEC_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_SPECCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SPECCOMP_SAVE') !== -1) ||
          (this.factorType === 'REG_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_REGCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_REGCOMP_SAVE') !== -1) ||
          (this.factorType === 'GOVT_PLANT_AUDIT' && this.ms_Permission.indexOf('QSPI_GOVTPLANT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTPLANT_SAVE') !== -1) ||
          (this.factorType === 'STOCK_RECOVERY' && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_SAVE') !== -1) ||
          (this.factorType === 'PRODUCT_FEEDBACK' && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_SAVE') !== -1) ||
          (this.factorType === 'SENSORY' && this.ms_Permission.indexOf('QSPI_SENSORY_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SENSORY_SAVE') !== -1) ||
          (this.factorType === 'QIP' && this.ms_Permission.indexOf('QSPI_OTHQIP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQIP_SAVE') !== -1) ||
          (this.factorType === 'ANTIBIOTIC_CHICKEN' && this.ms_Permission.indexOf('QSPI_ANTICHICK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_ANTICHICK_SAVE') !== -1) ||
          (this.factorType === 'QBR' && this.ms_Permission.indexOf('QSPI_OTHQBR_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQBR_SAVE') !== -1)
        ) {
          var aaa = Date.parse(new Date())
          var bbb = Date.parse(new Date(ele.deadline))
          if (bbb && aaa > bbb) {
            arr1.push(ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 已超过截止日期不能提交')
          }
        }
      }
      var valid1 = this.utils.validTable(arr1, h)
      if (!valid1) {
        return false
      }
      var arr2 = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const ele = this.multipleSelection[i];
        // 非SQMS时,如果指标类型为SWA不校验必填，其他指标类型等级必填、如果未填写，提示“请填写2021-01 Potato Facility1 的等级。”
        if (this.factorType !== "AAA" &&
          this.factorType !== "QBR" &&
          this.factorType !== "MSV" &&
          this.factorType !== "SWA" &&
          this.factorType !== "SQMS" &&
          this.factorType !== "SENSORY") {
          if (!ele.grade) {
            arr2.push('请填写 ' + ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 的等级')
          }
        }
        // SQMS时,分数必填
        // if (this.factorType === 'SQMS') {
        //   if (!ele.score) {
        //     arr2.push('请填写 ' + ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 的分数')
        //   }
        // }
      }
      var valid2 = this.utils.validTable(arr2, h)
      if (!valid2) {
        return false
      }
      otherApi.batchSubmit({
        factorScoreIds: this.factorScoreIds,
        factorType: this.factorType,
        voList: this.multipleSelection
      }).then(res => {
        if (res.code === '200') {
          this.$message.success('提交成功')
          this.factorScoreIds = []
          this.$refs['plxTable'].clearSelection()
          this.queryData()
        }
      });
    },
    onBatchModify() {
      if (this.factorScoreIds.length === 0) {
        this.$message.warning("请勾选数据")
        return false
      }
      // 不能进行提交的数据
      var arr1 = []
      const h = this.$createElement
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const ele = this.multipleSelection[i];
        if (!ele.isCanAudit) {
          arr1.push('您没有权限操作 ' + ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 的数据')
        }
        // 所有指标,超出截止日期时,CQS都不可以批量修改;但是owner超出截止日期都可以批量修改+批量提交
        if (
          (this.factorType === 'MSV' && this.ms_Permission.indexOf('QSPI_MSV_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_MSV_SAVE') !== -1) ||
          (this.factorType === 'SWA' && this.ms_Permission.indexOf('QSPI_SWA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SWA_SAVE') !== -1) ||
          (this.factorType === 'GOVT_CERT' && this.ms_Permission.indexOf('QSPI_GOVTCERT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTCERT_SAVE') !== -1) ||
          (this.factorType === 'COA' && this.ms_Permission.indexOf('QSPI_COA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_COA_SAVE') !== -1) ||
          (this.factorType === 'SQMS' && this.ms_Permission.indexOf('QSPI_SQMS_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SQMS_SAVE') !== -1) ||
          (this.factorType === 'SPEC_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_SPECCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SPECCOMP_SAVE') !== -1) ||
          (this.factorType === 'REG_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_REGCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_REGCOMP_SAVE') !== -1) ||
          (this.factorType === 'GOVT_PLANT_AUDIT' && this.ms_Permission.indexOf('QSPI_GOVTPLANT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTPLANT_SAVE') !== -1) ||
          (this.factorType === 'STOCK_RECOVERY' && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_SAVE') !== -1) ||
          (this.factorType === 'PRODUCT_FEEDBACK' && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_SAVE') !== -1) ||
          (this.factorType === 'SENSORY' && this.ms_Permission.indexOf('QSPI_SENSORY_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SENSORY_SAVE') !== -1) ||
          (this.factorType === 'QIP' && this.ms_Permission.indexOf('QSPI_OTHQIP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQIP_SAVE') !== -1) ||
          (this.factorType === 'ANTIBIOTIC_CHICKEN' && this.ms_Permission.indexOf('QSPI_ANTICHICK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_ANTICHICK_SAVE') !== -1) ||
          (this.factorType === 'QBR' && this.ms_Permission.indexOf('QSPI_OTHQBR_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQBR_SAVE') !== -1)
        ) {
          var aaa = Date.parse(new Date())
          var bbb = Date.parse(new Date(ele.deadline))
          if (bbb && aaa > bbb) {
            arr1.push(ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 已超过截止日期不能修改')
          }
        }
        //  所有指标,已提交状态时,CQS都不可以批量修改;但是owner 已提交状态都可以批量修改+批量提交
        if (
          (this.factorType === 'MSV' && this.ms_Permission.indexOf('QSPI_MSV_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_MSV_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SWA' && this.ms_Permission.indexOf('QSPI_SWA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SWA_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'GOVT_CERT' && this.ms_Permission.indexOf('QSPI_GOVTCERT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTCERT_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'COA' && this.ms_Permission.indexOf('QSPI_COA_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_COA_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SQMS' && this.ms_Permission.indexOf('QSPI_SQMS_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SQMS_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SPEC_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_SPECCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SPECCOMP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'REG_COMPLIANCE' && this.ms_Permission.indexOf('QSPI_REGCOMP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_REGCOMP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'GOVT_PLANT_AUDIT' && this.ms_Permission.indexOf('QSPI_GOVTPLANT_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_GOVTPLANT_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'STOCK_RECOVERY' && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHSTOCKRECOVER_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'PRODUCT_FEEDBACK' && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_PRDFEEDBACK_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'SENSORY' && this.ms_Permission.indexOf('QSPI_SENSORY_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_SENSORY_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'QIP' && this.ms_Permission.indexOf('QSPI_OTHQIP_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQIP_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'ANTIBIOTIC_CHICKEN' && this.ms_Permission.indexOf('QSPI_ANTICHICK_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_ANTICHICK_SAVE') !== -1 && ele.status === 'SCORED') ||
          (this.factorType === 'QBR' && this.ms_Permission.indexOf('QSPI_OTHQBR_OWNER') < 0 && this.ms_Permission.indexOf('QSPI_OTHQBR_SAVE') !== -1 && ele.status === 'SCORED')
        ) {
          arr1.push(ele.month + ' ' + ele.category2Name + ' ' + ele.facilityName + ' 评分已提交不能修改')
        }
      }
      var valid1 = this.utils.validTable(arr1, h)
      if (!valid1) {
        return false
      }
      this.showBatchEditDialog = true
    },
    scoreChange(val) {
      if (val) {
        // var reg = /^[1-9]\d*|0$/
        // if (!reg.test(val)) {
        //   this.$message.error('分数只能输入大于等于0的整数')
        //   return false
        // }
        this.$refs['detailForm'].validate((valid) => {
          if (valid) {
            otherApi.findGradeToScore('OTHER', val).then(res => {
              if (res.code === '200') {
                this.detailForm.grade = res.data
              }
            });
          }
        })
      }
    },
    onSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          otherApi.saveQspiScore({
            grade: this.detailForm.grade,
            score: this.detailForm.score,
            remark: this.detailForm.remark,
            factorScoreIds: this.factorScoreIds,
            voList: this.multipleSelection
          }).then(res => {
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.showBatchEditDialog = false
              this.factorScoreIds = []
              this.$refs['plxTable'].clearSelection()
              this.queryData();
            }
          });
        }
      })
    },
    closeDialog() {
      this.showBatchEditDialog = false
      this.detailForm = {
        grade: "",
        score: "",
        remark: "",
      }
      this.queryData();
    },
    closeHistoryDialog() {
      this.showHistoryDialog = false
      // var obj = JSON.parse(sessionStorage.getItem('obj'))
      this.queryData();
    },
    closeDetailDialog() {
      this.$refs['aaaa'].$refs['detailForm'].resetFields()
      this.showDetailDialog = false
      this.queryData();
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
